import { dictionary } from 'helpers/dictionary'
import { formatPrice } from 'helpers/formatters'

const formatAllPrices = {
  el: {
    prices: null as NodeListOf<HTMLElement> | null,
    loaders: null as NodeListOf<HTMLElement> | null,
  },

  init() {
    this.format()
    this.updateCurrencyExchangeText()
  },

  format() {
    this.el.prices = document.querySelectorAll('.price--universal')
    this.el.loaders = document.querySelectorAll('.price-loader')

    if (!this.el.prices.length) {
      return
    }

    const currency = localStorage.getItem('currency') || 'ISK'
    const rate = Number(localStorage.getItem('rate') || '1')

    this.el.prices.forEach((price) => {
      const rawNumber = price.getAttribute('data-price')
      const showSymbol = price.getAttribute('data-symbol')

      if (!rawNumber) {
        return
      }

      price.textContent = formatPrice(Number(rawNumber) / rate, showSymbol === 'false' ? '' : currency)
      price.classList.remove('hide')
    })

    this.el.loaders?.forEach((loader) => {
      loader.classList.add('hide')
    })
  },

  updateCurrencyExchangeText() {
    const currency = localStorage.getItem('currency') || 'ISK'
    const rate = Number(localStorage.getItem('rate') || '1')
    const currencyExchangeRateText = document.getElementById('currencyExchangeRate') as HTMLElement

    const rawNumber = document.querySelector(".pricing__price")?.getAttribute('data-price')
    const formattedNumber = formatPrice(Number(rawNumber))
    const totalPriceApprox = dictionary('trTotalPriceApprox')

    if (currencyExchangeRateText) {
      const parent = currencyExchangeRateText.parentElement
      if (parent) {
        if (rate === 1) {
          parent?.classList.add('hide')
        } else {
          parent?.classList.remove('hide')
          currencyExchangeRateText.innerHTML = `1 ISK = ${rate} ${currency}<br/>${totalPriceApprox} ${formattedNumber}`
        }
      }
    }
  },
}

export default formatAllPrices
